import React from "react";
import { Container, Label } from "./styles";

export const Checkbox = ({ id, label, ...rest }) => {
	return (
		<Container>
			<input id={id} className="checkbox-style" type="checkbox" {...rest} />
			<Label htmlFor={id}>{label}</Label>
		</Container>
	);
};
